import { AuditoriaProps } from '../../../interfaces'
import { SinTipoMonedaProps } from '../../../interfaces/sin.interface'

/**
 * Homologación de la moneda
 * Codigo debe ser igual al codigo del sin
 */
export interface MonedaProps extends AuditoriaProps {
  _id: string
  codigo: number // codigo del sin
  descripcion: string
  sigla: string
  tipoCambio: number
  tipoCambioCompra?: number
  activo: 0 | 1
  state?: string
}

export interface MonedaInputProps {
  sinMoneda: SinTipoMonedaProps | null // codigo del sin
  sigla: string
  descripcion: string
  tipoCambio: number
  tipoCambioCompra?: number
}

export interface MonedaApiInputProps {
  codigoSinMoneda: number
  sigla: string
  descripcion: string
  tipoCambio: number
  tipoCambioCompra?: number | null
}

export const MONEDA_DEFAULT = {
  sinMoneda: null,
  sigla: '',
  descripcion: '',
  tipoCambio: 0,
  tipoCambioCompra: 0,
}

export interface MonedaPrecioOperacionProp {
  moneda: MonedaProps
  precioBase: number // Precio base multiplicador por el factor de ajuste
  precio: number
}

/**
 * Relacion entre moneda y precio
 */
export interface MonedaPrecioProp {
  moneda: MonedaProps
  precioBase: number // Precio base multiplicador por el factor de ajuste
  precio: number
  delivery: number
  precioComparacion?: number | null
  manual: boolean // Si es false, no multiplica factorAjuste * precioBase
}

export interface MonedaPrecioApiInputProp {
  precioBase: number
  precio: number
  delivery: number
  manual: boolean
}
